import Vue from 'vue'
import Router from 'vue-router'
import Home from '../pages/Home'
import About from '../pages/About'
import Affiliate from '../pages/Affiliate'
import Blog from '../pages/Blog'
import CloudHosting from '../pages/CloudHosting'
import Contact from '../pages/Contact'
import DomainName from '../pages/DomainName'
import DedicatedHosting from '../pages/DedicatedHosting'
import Faq from '../pages/Faq'
import Pricing from '../pages/Pricing'
import Privacy from '../pages/Privacy'
import ResellerHosting from '../pages/ResellerHosting'
import SharedHosting from '../pages/SharedHosting'
import Support from '../pages/Support'
import Term from '../pages/Term'
import VpsHosting from '../pages/VpsHosting'
import Whois from '../pages/Whois'
import NotFound from '../components/NotFound'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/affiliate',
      name: 'affiliate',
      component: Affiliate
    },
    {
      path: '/blog',
      name: 'blog',
      component: Blog
    },
    {
      path: '/cloud-hosting',
      name: 'cloud-hosting',
      component: CloudHosting
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact
    },
    {
      path: '/dedicated-hosting',
      name: 'dedicated-hosting',
      component: DedicatedHosting
    },
    {
      path: '/domain-name',
      name: 'domain-name',
      component: DomainName
    },
    {
      path: '/faq',
      name: 'faq',
      component: Faq
    },
    {
      path: '/pricing',
      name: 'pricing',
      component: Pricing
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: Privacy
    },
    {
      path: '/reseller-hosting',
      name: 'reseller-hosting',
      component: ResellerHosting
    },
    {
      path: '/shared-hosting',
      name: 'shared-hosting',
      component: SharedHosting
    },
    {
      path: '/support',
      name: 'support',
      component: Support
    },
    {
      path: '/terms',
      name: 'terms',
      component: Term
    },
    {
      path: '/vps-hosting',
      name: 'vps-hosting',
      component: VpsHosting
    },
    {
      path: '/cloud-hosting',
      name: 'cloud-hosting',
      component: CloudHosting
    },
    {
      path: '/whois',
      name: 'whois',
      component: Whois
    },
    { path: '/:pathMatch(.*)*', component: NotFound }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js